import HttpClient from "../commons/HttpClient.js";

const signInEndPoint = "/api/signin";
const signOutEndPoint = "/api/auth/signout";
const changePasswordEndpoint = "/api/auth/change";
const forgotPasswordEndpoint = "/api/forgot";
const resetPasswordEndpoint = "/api/reset";


class AuthClient extends HttpClient {

    constructor(host, apiKey) {
        super();
        this._apiKey = apiKey;
        this._host = host;
    }

    async signIn(data) {
        let url = this._host + signInEndPoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        return this.makeRequest(
            url,
            "POST",
            data,
            headers
        );
    }

    async signOut() {
        let url = this._host + signOutEndPoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "POST",
            {},
            headers
        );
    }

    async changePassword(data) {
        let url = this._host + changePasswordEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "POST",
            data,
            headers
        );
    }
    async resetPassword(data, userId) {
        let query={
            userId: userId
        }
        let url = this.getUrl(this._host + changePasswordEndpoint,query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "POST",
            data,
            headers
        );
    }

    async forgotPassword(data) {
        let url = this._host + forgotPasswordEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        
        return this.makeRequest(
            url,
            "POST",
            data,
            headers
        );

    }

    // async resetPassword(data) {
    //     let url = this._host + resetPasswordEndpoint;
    //     let headers = {
    //         'Content-Type': 'application/json'
    //     };
    //     headers["X-API-KEY"] = this._apiKey;
    //     headers["X-DEVICE-ID"] = "aa=";
        
    //     return this.makeRequest(
    //         url,
    //         "POST",
    //         data,
    //         headers
    //     );

    // }

}

export default AuthClient;